import server from "./service";
import aes from "./aes";

const params = {
  quzgbxkh: "web",
  zqqOjkdoxw: "1.0.9",
  zqqOjkdoxwHxfj: "1",
}

// 发送验证码
export const sendCode = (data: any) => {
  return server({
    url: "/EjelO4kCv0",
    method: "POST",
    data: {
      fzgz: aes.aesEncrypt(
        JSON.stringify({ ...params, dhd_grqj: "8", ...data })
      ),
    },
  });
};

// 登录 / 核验验证码
export const login = (data: any) => {
  return server({
    url: "/4QdzeYnWBh",
    method: "POST",
    data: { fzgz: aes.aesEncrypt(JSON.stringify({ ...params, ...data })) },
  });
};

// 确认注销
export const clearAccount = (data: any) => {
  return server({
    url: "/gBqrziJ35e",
    method: "POST",
    data: { fzgz: aes.aesEncrypt(JSON.stringify({ ...params, ...data })) },
  });
};

// 客服信息
export const customerServiceInfo = (data: any) => {
  return server({
    url: "/GFiuZvMU9b",
    method: "POST",
    data: { fzgz: aes.aesEncrypt(JSON.stringify({ ...params, ...data })) },
  });
};

// 上传文件（图片/PDF 转 base64 后上传）
export const uploadImage = (data: any) => {
  return server({
    url: "/jd9Ioajcn",
    method: "POST",
    data: { fzgz: aes.aesEncrypt(JSON.stringify({ ...params, ...data })) },
  });
};

// 意见反馈/投诉提交
export const submitFeedback = (data: any) => {
  return server({
    url: "/Hauhcke12",
    method: "POST",
    data: { fzgz: aes.aesEncrypt(JSON.stringify({ ...params, ...data })) },
  });
};

// 意见反馈的 下拉选项
export const getFeedbackOptions = (data: any) => {
  return server({
    url: "/qyzucnkoa",
    method: "POST",
    data: { fzgz: aes.aesEncrypt(JSON.stringify({ ...params, ...data })) },
  });
};
